import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import groupBy from 'lodash/groupBy.js';

function createGroupRow(key, value, options) {
  return {
    [options.rowKey]: value,
    [key]: value,
    height: options.groupRowHeight || 32,
    isGroup: true
  };
}
function nest(data, keys, options) {
  if (!keys.length) {
    return data;
  }
  const first = keys[0];
  const rest = keys.slice(1);
  const grouped = groupBy(data, first);
  return Object.entries(grouped).map(entry => {
    const [key, value] = entry;
    const groupRow = createGroupRow(first, key, options);
    const children = nest(value, rest, options);
    return _objectSpread2(_objectSpread2({}, groupRow), {}, {
      [options.childKey]: children
    });
  });
}
function groupRows(_ref) {
  let {
    rows,
    options
  } = _ref;
  const keys = Array.isArray(options.groupKey) ? options.groupKey : [options.groupKey];
  return nest(rows, keys, options);
}

export { groupRows };
//# sourceMappingURL=group.js.map
